import React, { useEffect, useState } from 'react';
import { urunUrl, YuklenenLogoUrl } from '../Utils';
import { useTranslation } from 'react-i18next';
import { formatPrice } from '../helpers/formatPrice';
import ImageWithFallback from './ImageWithFallback';
import { useServiceMode } from "../helpers/UseServiceMode";
import { IoStorefront } from 'react-icons/io5';
import { MdDeliveryDining } from 'react-icons/md';

export default function Product({ visible, categories, products, currencySymbol, initialKey, companyLogo, companyColor, companyServiceModeState }) {
    const { t, i18n } = useTranslation("translation", { keyPrefix: "product" });
    const [selectedKey, setSelectedKey] = useState(0);
    const [currencyTourSymbol, setCurrencyTourSymbol] = useState(currencySymbol);
    const serviceMode = useServiceMode();

    const companyLogoSrc = companyLogo ? `${YuklenenLogoUrl}${companyLogo}` : null;

    useEffect(() => {
        setCurrencyTourSymbol(currencySymbol);
    }, [currencySymbol]);

    useEffect(() => {
        if (!visible || initialKey == null) return;

        setSelectedKey(initialKey);

        const section = document.getElementById(`cat-${initialKey}`);
        section?.scrollIntoView({ behavior: 'smooth', block: 'start' });

        const navEl = document.querySelector('.custom_category-nav');
        const activeLink = navEl?.querySelector(
            `.custom_category-nav-item[href="#cat-${initialKey}"]`
        );
        activeLink?.scrollIntoView({
            behavior: 'smooth',
            inline: 'center',
            block: 'nearest'
        });
    }, [visible, initialKey]);

    useEffect(() => {
        if (!visible) return;
        const navEl = document.querySelector('.custom_category-nav');
        const navHeight = navEl?.offsetHeight || 0;

        const handleScroll = () => {
            let current = selectedKey;
            categories.forEach(cat => {
                const section = document.getElementById(`cat-${cat.Id}`);
                if (section) {
                    const top = section.getBoundingClientRect().top;
                    if (top <= navHeight + 1) {
                        current = cat.Id;
                    }
                }
            });
            setSelectedKey(current);
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll();
        return () => window.removeEventListener('scroll', handleScroll);
    }, [visible, categories, selectedKey]);

    useEffect(() => {
        if (!visible) return;
        const navEl = document.querySelector('.custom_category-nav');
        if (!navEl) return;

        const activeLink = navEl.querySelector(
            `.custom_category-nav-item[href="#cat-${selectedKey}"]`
        );
        if (activeLink && activeLink.scrollIntoView) {
            activeLink.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center'
            });
        }
    }, [selectedKey]);

    if (!visible) return null;

    return (
        <div className="custom_menu-products-page">
            <nav className="custom_category-nav" style={{ ["--custom_category-nav-accent"]: companyColor }}>
                {categories.map(cat => (
                    <a
                        key={cat.Id}
                        href={`#cat-${cat.Id}`}
                        className={
                            'custom_category-nav-item' +
                            (selectedKey === cat.Id ? ' active' : '')
                        }
                        onClick={() => setSelectedKey(cat.Id)}
                    >
                        {cat.Adi}
                    </a>
                ))}
            </nav>

            {categories.map(cat => {
                const prods = products.filter(p => p.UrunGrubu.Id === cat.Id);
                return (
                    <section
                        key={cat.Id}
                        id={`cat-${cat.Id}`}
                        className="custom_category-section-block"
                    >
                        <h2 className="custom_category-section-title">{cat.Adi}</h2>

                        <div className="custom_product-grid">
                            {prods.map((p, index) => {
                                const primarySrc = p?.Resim ? `${urunUrl}kucukresimler/${p.Resim}` : null;
                                const priceToShow = serviceMode === "pickup" && p.MasaFiyati > 0 ? p.MasaFiyati : p.BirimFiyat;
                                const ServiceIcon = serviceMode === "pickup" ? IoStorefront : MdDeliveryDining;
                                return (
                                    <div key={p.Id} className="custom_product-card">

                                        <ImageWithFallback
                                            src={primarySrc}
                                            fallbackSrc={companyLogoSrc}
                                            alt={p?.Adi || "Ürün"}
                                            className="custom_product-card-image"
                                            fetchPriority={index < 2 ? 'high' : 'low'}
                                        />
                                        <div className="custom_product-card-body">
                                            <h3 className="custom_product-card-title">
                                                {p.Adi}
                                            </h3>
                                            <p className="custom_product-card-desc">
                                                {p.Aciklama}
                                            </p>
                                            <div className="custom_product-card-footer" style={{ ["--card-btn-accent"]: companyColor }}>
                                                <button className="custom_product-card-button">
                                                    {t("price", { price: formatPrice(priceToShow, i18n.language), currency: currencyTourSymbol })}
                                                </button>
                                                <button className="custom_product-card-button" style={{marginLeft:"0.5em"}} aria-label={serviceMode}>
                                                    <ServiceIcon size={18} />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )

                            })}
                            {prods.length === 0 && (
                                <p className="custom_no-products">
                                    {t("noProductsInThisCategory")}
                                </p>
                            )}
                        </div>
                    </section>
                );
            })}
        </div>
    );
}
